import React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@app/common/store";
import { GlobalStyle } from "@app/common/styles/GlobalStyle";
import { LandingPage } from "./landing-page/LandingPage";
import { RegisterPage } from "./register-page/RegisterPage";
import { NotFoundPage } from "./common/components/NotFoundPage";
import { D2CPage } from "./landing-page/D2CPage";

export const App: React.VFC = () => (
  <>
    <Provider store={store}>
      <BrowserRouter basename={GLOBAL_CONFIG.baseUrl}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/apply" element={<D2CPage />} />
          <Route element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </Provider>
    <GlobalStyle />
  </>
);
